<script>
import logo from "@/mixins/logo";
import session from "@/services/session";
import segmentService from "@/services/segment";

export default {
  name: "PasswordForgot",

  mixins: [logo],

  data() {
    return {
      username: "",
      isLoading: false,
      expiredPassword: this.$route.params.expiredPassword,
    };
  },

  methods: {
    resetPassword() {
      segmentService.track({ name: "Password Forgot" });
      this.isLoading = true;

      session.sendPasswordResetByUsername(this.username).finally(() => {
        this.isLoading = false;
        this.$message.info(
          "En caso de que exista una cuenta asociada, le enviaremos un email"
        );
        this.$router.push({ name: "login" });
      });
    },
  },
};
</script>

<template lang="pug">
  .login
    .login__container
      ValidationObserver(v-slot="{handleSubmit}")
        form.login__card(@submit.prevent="handleSubmit(resetPassword)")
          .login__img
            micon.login__svg(:name="'quantux-logo-horizontal'")
          h3.login__expired(v-show="expiredPassword") Su contraseña ha expirado. Por favor ingrese su usuario y recibirás un correo para generar una nueva
          ValidationProvider(name="Usuario" rules="required" v-slot="{ errors }")
            el-input#username(placeholder="Usuario" required autofocus="true" v-model="username" autocapitalize="none")
            span.has-error {{ errors[0] }}
          el-button(type="primary" native-type="submit" :disabled="!username" :loading="isLoading") Restablecer Contraseña
          router-link.login__link(:to="{ name: 'login' }") Iniciar Sesión
</template>
